<template>
  <component>
    <li class="upperSidebar__item">
      <div
        class="upperSidebar__link"
        :class="{ 'upperSidebar__link--active': isActiveLink }"
        @click="selectPage(routeName)"
      >
        {{ name }}
      </div>
    </li>
  </component>
</template>

<script>
export default {
  name: 'PublicUpperSidebarLink',
  props: {
    name: {
      type: String,
    },
    routeName: {
      type: String,
    },
    currentPage: String,
  },
  data: function () {
    return {
      notifications: null,
    };
  },
  computed: {
    isActiveLink() {
      return this.currentPage === this.routeName;
    },
  },
  methods: {
    selectPage(routeName) {
      this.$emit('pageChanged', routeName);
    },
  },
};
</script>

<style scoped></style>
